/**
 * State Name
 */
export const SENT_MESSAGES = 'SENT_MESSAGES';
